import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import connectivityService from '../device/connectivityService';
import fwuService from '../device/fwuService';
import advanceDiagnosticService from '../yap/advanceDiagnosticService';
import amplitude from './amplitude';

const trackUpgradeStartedFromDeviceInSbl = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.FIRMWARE_UPGRADE_STARTED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SOURCE]: AMPLITUDE_EVENT_VALUES.FWU_DEVICE_IN_SBL_ALERT,
            [AMPLITUDE_EVENT_PROPERTIES.CONNECTION_TYPE]: AMPLITUDE_EVENT_VALUES.USB_MODE,
        },
    });
};

const trackUpgradeStarted = (isHolder) => {
    const isBle = connectivityService.isBle();
    const isAutoCheck = fwuService.getIsBackgroundFwuCheckEnabled();
    const isAdRedirect = advanceDiagnosticService.isAfterFwuAdvanceDiagnosticRedirect();
    const source = isAdRedirect
        ? AMPLITUDE_EVENT_VALUES.FWU_ADVANCED_DIAGNOSTICS_RESULT
        : isAutoCheck
        ? AMPLITUDE_EVENT_VALUES.FWU_DEVICE_SETTINGS_AUTO_CHECK
        : AMPLITUDE_EVENT_VALUES.FWU_DEVICE_SETTINGS_MANUAL_CHECK;

    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.FIRMWARE_UPGRADE_STARTED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SOURCE]: source,
            [AMPLITUDE_EVENT_PROPERTIES.CONNECTION_TYPE]: isBle
                ? AMPLITUDE_EVENT_VALUES.BLUETOOTH_MODE
                : AMPLITUDE_EVENT_VALUES.USB_MODE,
        },
    });
};

const trackUpgradeCompleted = (isHolder) => {
    const isBle = connectivityService.isBle();

    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.FIRMWARE_UPGRADE_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: true,
            [AMPLITUDE_EVENT_PROPERTIES.CONNECTION_TYPE]: isBle
                ? AMPLITUDE_EVENT_VALUES.BLUETOOTH_MODE
                : AMPLITUDE_EVENT_VALUES.USB_MODE,
        },
    });
};

const trackUpgradeFailed = ({isHolder, errorMessage}) => {
    const isBle = connectivityService.isBle();

    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.FIRMWARE_UPGRADE_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: false,
            [AMPLITUDE_EVENT_PROPERTIES.ERROR_MESSAGE]: errorMessage,
            [AMPLITUDE_EVENT_PROPERTIES.CONNECTION_TYPE]: isBle
                ? AMPLITUDE_EVENT_VALUES.BLUETOOTH_MODE
                : AMPLITUDE_EVENT_VALUES.USB_MODE,
        },
    });
};

export default {
    trackUpgradeStartedFromDeviceInSbl,
    trackUpgradeStarted,
    trackUpgradeCompleted,
    trackUpgradeFailed,
};
